const advantages = [
  {
    icon: "ri-settings-5-line",
    title: "Individueller Service",
    text: "Auf Anfrage fertigen wir Sonderausführungen nach Ihrem Muster oder Ihrer Zeichnung.",
  },
  {
    icon: "ri-stack-line",
    title: "Fertigungslose ab 300 Stück",
    text: "Wirtschaftliche Serienfertigung – auch bei kleinen und mittleren Losgrößen.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Gleichbleibende Qualität",
    text: "Maßhaltige Präzisionsteile, gefertigt in Deutschland mit über 65 Jahren Erfahrung.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Persönliche Beratung",
    text: "Direkter Kontakt zur Werkstatt: Telefon, Fax oder Kontaktformular – ohne Umwege.",
  },
];

const stats = [
  { value: "1956", label: "Gründungsjahr" },
  { value: "300+", label: "Stück pro Fertigungslos" },
  { value: "6", label: "Stiftfamilien" },
  { value: "100%", label: "Fertigung in Deutschland" },
];

function CompanySection() {
  return (
    <section id="unternehmen-teaser" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.18em] text-primary-600">
              Seit 1956
            </p>
            <h2 className="mt-3 font-heading font-semibold text-2xl md:text-4xl text-foreground-950">
              Spezialfabrik für Drückerverbindungen
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              Seit der Gründung im Jahr 1956 fertigt die Franz Drexelius Metallverarbeitung GmbH in
              Finnentrop-Heggen Verbindungselemente für die Tür- und Beschlagtechnik. Was als kleine
              Werkstatt begann, ist heute eine spezialisierte Fabrik für Drücker-, Schloss- und
              Vierkant-Stifte.
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              Wir liefern an Beschlaghersteller, den Fachgroßhandel und Handwerksbetriebe. Im
              Mittelpunkt steht dabei immer die passgenaue Lösung: maßhaltige Präzisionsteile, die
              dauerhaft funktionieren – und die Bereitschaft, auch Sonderwünsche zu fertigen.
            </p>

            <dl className="mt-9 grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-5"
                >
                  <dt className="font-label text-[11px] uppercase tracking-wide text-foreground-500">
                    {stat.label}
                  </dt>
                  <dd className="mt-1 font-heading font-semibold text-2xl md:text-3xl text-primary-600">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {advantages.map((item) => (
              <article
                key={item.title}
                className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
              >
                <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading font-semibold text-base md:text-lg text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CompanySection;